// Main Cart JavaScript
// Handles main cart page functionality including quantity updates and checkout

// Get main cart element
var cartMain = document.querySelector('.cart-main');

// Function to update the main cart content
async function updateCartMain() {
    fetch('/?section_id=main-cart')
        .then(function(response) {
            return response.text();
        })
        .then(function(html) {
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            var newCartMain = tempDiv.querySelector('.cart-main');
            
            if (newCartMain && cartMain) {
                cartMain.innerHTML = newCartMain.innerHTML;
                attachCartMainListeners();
            }
        })
        .catch(function(error) {
            console.error('Error refreshing cart drawer:', error);
        });
}

// Function to update a line item quantity in main cart
async function updateCartMainLineItem(lineItemKey, quantity) {
    await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            updates: {
                [lineItemKey]: quantity
            }
        })
    });
    
    await updateCartMain();
    await updateCartDrawer();
    
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    updateCartCount(cart.item_count);
}

// Function to attach event listeners to main cart elements
function attachCartMainListeners() {
    // Quantity selector listeners for main cart
    document.querySelectorAll('.cart-main .quantity-selector').forEach(selector => {
        const minusBtn = selector.querySelector('.cart-main__quantity__button--minus');
        const plusBtn = selector.querySelector('.cart-main__quantity__button--plus');
        const input = selector.querySelector('input[type="number"], input[type="text"]');
        const lineItemKey = minusBtn?.dataset.lineitemKey || plusBtn?.dataset.lineitemKey || input?.dataset.itemKey;
        
        // Minus button functionality
        if (minusBtn) {
            minusBtn.onclick = async () => {
                let qty = parseInt(input.value, 10);
                if (qty > 1) {
                    await updateCartMainLineItem(lineItemKey, qty - 1);
                } else {
                    await updateCartMainLineItem(lineItemKey, 0);
                }
            };
        }
        
        // Plus button functionality
        if (plusBtn) {
            plusBtn.onclick = async () => {
                let qty = parseInt(input.value, 10);
                await updateCartMainLineItem(lineItemKey, qty + 1);
            };
        }
    });
    
    // Checkout button functionality
    const checkoutBtn = document.querySelector('.cart-main__checkout-btn');
    if (checkoutBtn) {
        checkoutBtn.onclick = function(e) {
            e.preventDefault();
            const cartDrawer = checkoutBtn.closest('.cart-main');
            const orderMsgWrapper = cartDrawer.querySelector('.order-message');
            let msg = orderMsgWrapper?.querySelector('.order-message-text')?.value || "";
            if(!orderMsgWrapper?.querySelector('input[type="checkbox"]:checked')) {
                msg = '';
            }
            fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    attributes: { Notes: `Message: ${msg}` }
                })
                }).then(res=>res.json()).then(res=>{
                console.log(res);
                window.location.href = checkoutBtn.getAttribute('data-checkout-url') || '/checkout';
            }).catch(err=>{
                console.error(err);
                window.location.href = checkoutBtn.getAttribute('data-checkout-url') || '/checkout';
            });
        };
    }
}

// Initialize main cart listeners when DOM is ready
document.addEventListener('DOMContentLoaded', attachCartMainListeners);